export const transformStaffOptions = (staffMembers) =>
  (staffMembers ?? []).map((s) => ({
    value: String(s.id),
    label: `${s.active ? "✅ " : ""}${s.firstName} ${s.lastName}${
      s.staffRole ? ` (${s.staffRole.toLowerCase()})` : ""
    }`,
  }));
